var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "units",
    transform: "translate(0.000000, 0.500000)",
    fill: "#384C7E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4,4.71428571 C3.2825,4.71428571 4,4.00959821 4,3.14285714 C4,2.27611607 3.2825,1.57142857 2.4,1.57142857 C1.5175,1.57142857 0.8,2.27611607 0.8,3.14285714 C0.8,4.00959821 1.5175,4.71428571 2.4,4.71428571 Z M13.6,4.71428571 C14.4825,4.71428571 15.2,4.00959821 15.2,3.14285714 C15.2,2.27611607 14.4825,1.57142857 13.6,1.57142857 C12.7175,1.57142857 12,2.27611607 12,3.14285714 C12,4.00959821 12.7175,4.71428571 13.6,4.71428571 Z M14.4,5.5 L12.8,5.5 C12.36,5.5 11.9625,5.67433036 11.6725,5.95669643 C12.68,6.49933036 13.395,7.47901786 13.55,8.64285714 L15.2,8.64285714 C15.6425,8.64285714 16,8.29174107 16,7.85714286 L16,7.07142857 C16,6.2046875 15.2825,5.5 14.4,5.5 Z M8,5.5 C9.5475,5.5 10.8,4.26986607 10.8,2.75 C10.8,1.23013393 9.5475,0 8,0 C6.4525,0 5.2,1.23013393 5.2,2.75 C5.2,4.26986607 6.4525,5.5 8,5.5 Z M9.92,6.28571429 L9.7125,6.28571429 C9.1925,6.53125 8.615,6.67857143 8,6.67857143 C7.385,6.67857143 6.81,6.53125 6.2875,6.28571429 L6.08,6.28571429 C4.49,6.28571429 3.2,7.55267857 3.2,9.11428571 L3.2,9.82142857 C3.2,10.4720982 3.7375,11 4.4,11 L11.6,11 C12.2625,11 12.8,10.4720982 12.8,9.82142857 L12.8,9.11428571 C12.8,7.55267857 11.51,6.28571429 9.92,6.28571429 Z M4.3275,5.95669643 C4.0375,5.67433036 3.64,5.5 3.2,5.5 L1.6,5.5 C0.7175,5.5 0,6.2046875 0,7.07142857 L0,7.85714286 C0,8.29174107 0.3575,8.64285714 0.8,8.64285714 L2.4475,8.64285714 C2.605,7.47901786 3.32,6.49933036 4.3275,5.95669643 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/Unit.db0ee04e.svg";
export { ForwardRef as ReactComponent };